import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ContentState, convertToRaw, EditorState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import AssetWysiwygTableButton from './AssetWysiwygTableButton';

export default class AssetWysiwygEditor extends Component {

    constructor(props) {
        super(props);

        let editorState;
        if (!!props.value && props.value.trim() !== '') {
            const processedHTML = htmlToDraft(props.value);
            const contentState = ContentState.createFromBlockArray(processedHTML);
            editorState = EditorState.createWithContent(contentState);
        } else {
            editorState = EditorState.createEmpty();
        }
        this.state = { editorState };
        this.onEditorStateChange = this.onEditorStateChange.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (nextProps.value !== this.props.value || nextState !== this.state);
    }

    onEditorStateChange(editorState) {
        const {onChange, value} = this.props;
        const newValue = this.markupToHtml(draftToHtml(convertToRaw(editorState.getCurrentContent())));
        if (value !== newValue) {
            onChange(newValue);
        }
        this.setState({ editorState });
    };


    markupToHtml(content) {
        // table markup
        return content.replace(/\+=======TABLE=======\+(?:<br\s*\/?>)*(?:(?:\|\|(?:[^|]+\|\|)+)?(?:<br\s*\/?>)+(?:<span[^|]>)?(?:\|(?:[^|]+\|)+)(?:<\/span>)?)+(?:<br\s*\/?>)+\+===================\+/g, (match) => {
            let newContent = match.replace('+=======TABLE=======+', '\n<table width="100%" border="2" style="border-collapse: collapse" >');
            newContent = newContent.replace('+===================+', '\n</table>\n');

            newContent = newContent.replace(/<\/?span[^|>]*>/g, '');
            newContent = newContent.replace(/<p>/g, '');
            newContent = newContent.replace(/<\/p>\n*/g, '<br>');

            newContent = newContent.replace(/(<br\s*\/?>)\|\|([\w\s]*)\|\|/g, '$1\n\t<tr>\n\t\t<th>$2</th>\n\t\t<th>');
            newContent = newContent.replace(/([\w\s]*)\|\|(<br\s*\/?>)/g, '$1</th>\n\t</tr>$2');
            newContent = newContent.replace(/([\w\s]*)\|\|/g, '$1</th>\n\t\t<th>');

            newContent = newContent.replace(/(<br\s*\/?>)\|([\w\s]*)\|/g, '$1\n\t<tr>\n\t\t<td>$2</td>\n\t\t<td>');
            newContent = newContent.replace(/([\w\s]*)\|(<br\s*\/?>)/g, '$1</td>\n\t</tr>$2');
            newContent = newContent.replace(/([\w\s]*)\|/g, '$1</td>\n\t\t<td>');

            newContent = newContent.replace(/<br\s*\/?>/g, '');

            return newContent;
        });
    }

    render() {
        const toolbarOptions = {
            options: [
                'inline',
                'blockType',
                'fontSize',
                'fontFamily',
                'list',
                'textAlign',
                'link',
                'embedded',
                'remove',
                'history',
                'image'
            ],
            inline: {inDropdown: true},
            list: {inDropdown: true},
            textAlign: {inDropdown: true},
            link: {inDropdown: true},
            history: {inDropdown: true},
            image: {
                uploadEnabled: true,
                uploadCallback: this.props.uploadCallback,
                alt: {present: true, mandatory: false},
                inputAccept: 'image/gif,image/jpeg,image/png'
            }
        };

        return (
            <Editor
                editorState={this.state.editorState}
                onEditorStateChange={this.onEditorStateChange}
                toolbar={toolbarOptions}
                toolbarCustomButtons={[<AssetWysiwygTableButton />]}
                {...this.props.editorProps}
            />
        );
    }
};

AssetWysiwygEditor.propTypes = {
    value: PropTypes.string,

    onChange: PropTypes.func.isRequired,
    uploadCallback: PropTypes.func,
    editorProps: PropTypes.object
};
